export const LISTE_OPERATION_DIVERSE = {
  title: 'Opérations diverses',
  racine: 'Accueil',
  actions: {
    add: 'Ajouter une opération diverse',
    export: 'Exporter au format excel',
    search: 'Rechercher',
  },
  tab: {
    compteComptable: 'Compte comptable',
    dateMouvement: 'Date mouvement',
    libelle: 'Libellé',
    debit: 'Débit',
    credit: 'Crédit',
    tiers: 'Tiers',
    etat: 'Etat',
  },
  filtre: {
    tiers: 'Tiers',
    libelle: 'Libellé',
    date: 'Date mouvement',
  },
  etat: {
    valide: 'Validé',
    enregistre: 'Enregistré',
  },
  messages: {
    successSuppression: 'Opération diverse supprimée avec succès',
    successSuppressionMulti: 'Opérations diverses supprimées avec succès',
  },
  popUpSuppression: {
    title: 'Etes-vous sûr de vouloir supprimer cette opération diverse ?',
    titleMulti: 'Etes-vous sûr de vouloir supprimer ces opérations diverses ?',
  },
};

export const ADD_OPERATION_DIVERSE = {
  titleAdd: 'Ajouter une opération diverse',
  titleEdit: 'Modifier une opération diverse',
  actions: {
    addNewLine: 'Nouvelle ligne',
  },
  aucuneLigne: 'Aucune ligne',
  informationsMouvement: {
    search: 'Recherche tiers',
    title: 'Mouvement auxiliaire',
    dateMouvement: 'Date mouvement',
    montant: 'Montant',
    sens: 'Sens',
    tiers: 'Tiers',
  },
  informationsLigne: {
    title: 'Contreparties',
    ligneCompteTva: 'Tva',
    compteAuxiliaire: 'Compte auxiliaire',
  },
  journal: 'Journal',
  debit: 'Débit',
  credit: 'Crédit',
  libelle: 'Libellé',
  compteComptable: 'Compte comptable',
  reference: 'Référence',
  exportOdComptabilite: 'Exporter en comptabilité',
  totalDebit: 'Total débit :',
  totatCredit: 'Total crédit :',
  messages: {
    successCreation: 'Création de l\'operation diverse réalisée avec succès',
    successModification: 'Modification de l\'operation diverse réalisée avec succès',
    errorMessage: 'Le mouvement est lettré, il n\'est plus modifiable.',
    successSuppression: 'Opération diverse supprimée avec succès',
    successSuppressionMulti: 'Opérations diverses supprimées avec succès',
  },
  validation: {
    forbiddenCreateOrUpdate: 'La somme des débits et celle des crédits doivent être égales',
    forbiddenCreateOrUpdateLetteredTransaction: 'Le montant doit être renseigné',
    forbiddenUpdateAtValidateState: 'Impossible de modifier une opération diverse à l\'état "Validé"',
  },
  typeTiers: {
    client: 'Clients',
    bailleur: 'Bailleurs',
  },
};

export const DETAIL_OPERATION_DIVERSE = {
  title: 'Détail opération diverse',
  onglet: {
    ecritureCompta: 'Ecriture comptable',
    operationDiverse: 'Opération diverse',
  },
  actions: {
    generateEcriture: 'MAJ Ecriture',
    validation: 'Valider l\'OD',
  },
  informationsMouvement: {
    tiers: 'Tiers :',
    title: 'Mouvement auxiliaire :',
    adresse: 'Adresse postale :',
    dateMouvement: 'Date mouvement :',
    compteComptable: 'Compte comptable :',
    libelle: 'Libellé :',
    reference: 'Référence :',
    debit: 'Débit :',
    credit: 'Crédit :',
  },
  informationsLigne: {
    title: 'Contreparties',
    ligneCompteTva: 'Tva',
    compteAuxiliaire: 'Compte auxiliaire',
  },
  journal: 'Journal',
  debit: 'Débit',
  credit: 'Crédit',
  libelle: 'Libellé',
  compteComptable: 'Compte comptable',
  reference: 'Référence',
  exportOdComptabilite: 'Exporter en comptabilité',
  totalDebit: 'Total débit :',
  totatCredit: 'Total crédit :',
  messages: {
    successGenerateEcriture: 'Ecriture mise à jour avec succès',
    successValidation: 'Validation de l\'opération diverse réalisée avec succès.',
    noValidation: 'Seules les opérations diverses exportables en comptabilité sont validables',
    successSuppression: 'Opération diverse supprimée avec succès',
  },
  validation: {
    title: 'Etes-vous sûr de vouloir valider cette opération diverse ?',
    errors: {
      forbiddenValidationAtValidateState: 'L\'opération diverse a déjà été validée',
      invalideEcritureComptable: 'Validation impossible : l\'écriture comptable est en erreur',
    },
  },
  popUpSuppression: {
    title: 'Etes-vous sûr de vouloir supprimer cette opération diverse ?',
    errors: {
      forbidden_DeleteMouvementOdIfIsLettre: 'Impossible de supprimer le mouvement OD {libelle}, il est lettré ou partiellement lettré',
      forbidden_DeleteODIfAtValidateState: 'Impossible de supprimer l\'opération diverse {reference}, elle est à l\'état "Validé"',
    },
  },
};
